import { Component, inject } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { FwButtonModule, FwLayoutsModule } from '@flywheel-io/vision';
import { ProfileService } from '../../profile/profile.service';
import { toSignal } from '@angular/core/rxjs-interop';
import { RoutingHelperService } from '../../routing-helper.service';

@Component({
  selector: 'project-no-access',
  imports: [
    FwLayoutsModule,
    FwButtonModule,
    RouterModule,
  ],
  template: `
    <header class="content-header">
    </header>
    <fw-layout-context title="You don't have access to this project" icon="lock" description="Your sign-in was successful but you don’t have permission to access this resource.">
        <fw-button routerLink="/projects" variant="outline" leftIcon="folder-open">
          Projects
        </fw-button>
        @if (isSiteAdmin()) {
          <fw-button (click)="enableExhaustiveMode()" color="secondary" variant="outline" leftIcon="crown-style-circle">
            Manage Site Mode
          </fw-button>
        }

    </fw-layout-context>
  `,
  styles: [`
    :host {
      width: 100%;
      height: 100%;
      background: var(--page-light);
      display: flex;
      flex-direction: column;

      header {
        margin: 0;
      }

      fw-layout-context {
        flex-grow: 1;
        width: 100%;
      }
    }
  `],
})
export class ProjectNoAccessComponent {

  profileService = inject(ProfileService);
  routingHelper = inject(RoutingHelperService);
  activeRoute = inject(ActivatedRoute);
  router = inject(Router);

  isSiteAdmin = toSignal(this.profileService.siteAdmin$);

  enableExhaustiveMode(): void {
    this.profileService.showAllData = true;
    const projectId = this.routingHelper.getGlobalRouteParams().projectId;

    this.router.navigate(['projects', projectId]);
  }
}
